import { forwardRef } from "react";
import { Link, LinkProps } from "react-router-dom";

interface GenericLinkProps extends LinkProps {
  label: string;
  className?: string;
}

export const GenericLink = forwardRef<HTMLAnchorElement, GenericLinkProps>(
  (
    {
      to,
      label,
      className = "text-blue-500 hover:text-blue-700 font-semibold",
      ...rest
    },
    ref
  ) => {
    return (
      <Link ref={ref} to={to} className={className} {...rest}>
        {label}
      </Link>
    );
  }
);
